/**
 * VERADE · Cabecera que se oculta al bajar y vuelve al subir
 * Archivo: assets/verade-header-scroll.js (se carga desde layout/theme.liquid)
 *
 * Necesita «Encabezado fijo: Siempre» en el editor de temas. El tema deja la
 * cabecera fija arriba y este script solo decide si se ve o no, poniendo
 * data-vrd-hidden en la sección (la animación está en custom.css).
 * Con cualquier otro valor del ajuste, el script no hace nada.
 *
 * Reglas:
 *  · Arriba del todo, mientras se ve el hueco de la cabecera, siempre visible.
 *  · Se oculta tras bajar 12 px seguidos y vuelve tras subir 12 px seguidos.
 *    Los temblores de pocos píxeles (final de un deslizamiento, barra del
 *    navegador que aparece y desaparece) no la mueven.
 *  · No se oculta con el menú o un desplegable abiertos, ni con el foco de
 *    teclado dentro de la cabecera.
 *  · El rebote al final de la página no la hace aparecer.
 */
(function () {
  'use strict';

  var TOLERANCE = 12;

  function init() {
    var header = document.getElementById('header-component');
    if (!header || header.getAttribute('sticky') !== 'always') return;

    var section = header.closest('.header-section') || header.parentElement;
    if (!section) return;

    var main = document.getElementById('MainContent');
    var lastY = currentY();
    var anchorY = lastY;
    var goingDown = true;
    var hidden = false;
    var ticking = false;

    function currentY() {
      var root = document.scrollingElement || document.documentElement;
      var max = Math.max(root.scrollHeight - window.innerHeight, 0);
      var y = window.scrollY || root.scrollTop || 0;
      return Math.min(Math.max(y, 0), max);
    }

    // El hueco natural de la cabecera aún se ve (estamos arriba del todo)
    function slotVisible() {
      if (main) return main.getBoundingClientRect().top > 0;
      return lastY <= section.offsetHeight;
    }

    function canHide() {
      if (header.querySelector('.menu-drawer-container[open], [aria-expanded="true"], :focus-visible')) return false;
      return true;
    }

    function setHidden(value) {
      if (value === hidden) return;
      hidden = value;
      if (value) section.setAttribute('data-vrd-hidden', '');
      else section.removeAttribute('data-vrd-hidden');
    }

    function update() {
      ticking = false;
      var y = currentY();
      if (y === lastY) return;

      var down = y > lastY;
      if (down !== goingDown) {
        goingDown = down;
        anchorY = lastY;
      }
      lastY = y;

      if (slotVisible()) {
        anchorY = y;
        setHidden(false);
        return;
      }

      if (Math.abs(y - anchorY) < TOLERANCE) return;
      setHidden(goingDown && canHide());
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // Si alguien entra en la cabecera con el teclado, se muestra
    header.addEventListener('focusin', function (event) {
      var target = event.target;
      if (target && target.matches && target.matches(':focus-visible')) setHidden(false);
    });

    // Al volver a la página con «Atrás», empezar visible
    window.addEventListener('pageshow', function () {
      lastY = currentY();
      anchorY = lastY;
      setHidden(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
